import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoginRequest } from "../../models/LoginRequest.model";
import { LoginResponse } from "../../models/LoginResponse.model";
import { environment } from "../../environments";

const API_URL = environment.apiUrl;

export const loginUser = createAsyncThunk<
  LoginResponse,
  LoginRequest,
  { rejectValue: string }
>("auth/login", async (loginData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(loginData),
    });

    if (!response.ok) {
      return rejectWithValue("שם משתמש או סיסמה שגויים");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return rejectWithValue("שגיאת התחברות. נסה שוב מאוחר יותר.");
  }
});

export const logoutUser = createAsyncThunk(
  "auth/logout",
  async (_, { dispatch: _dispatch }) => {
    try {
      // נקה localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("companyKey");
      localStorage.removeItem("companies");
      localStorage.removeItem("persist:root");

      // נקה sessionStorage
      sessionStorage.clear();

      return { success: true };
    } catch (error) {
      console.error("Logout error:", error);
      return { success: false };
    }
  },
);
